import { render, staticRenderFns } from "./box12.vue?vue&type=template&id=b8f1ce22&scoped=true&"
import script from "./box12.vue?vue&type=script&lang=js&"
export * from "./box12.vue?vue&type=script&lang=js&"
import style0 from "./box12.vue?vue&type=style&index=0&id=b8f1ce22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f1ce22",
  null
  
)

export default component.exports